import React, { useState, useEffect } from "react";
import {
  AiFillDelete,
  AiFillEdit,
  AiFillPlusCircle,
  AiOutlineUpload,
  AiOutlineUser,
  AiOutlinePhone,
  AiOutlineMail,
  AiOutlineIdcard,
  AiOutlineCalendar,
  AiOutlineGlobal,
  AiOutlineHeart,
  AiOutlineTeam,
  AiOutlineCheckCircle,
  AiOutlineDownload,
} from "react-icons/ai";
import jsPDF from "jspdf";
import axios from "axios";
import swal from "sweetalert";
import EditInfo1 from "./modal/EditInfo1";
import EditInfo3 from "./modal/EditInfo3";
import Distribute from "./modal/AgentForm";
import Recipient from "./modal/Recipient";
import Modal from "../../components/Modal";
import UploadDocument from "../../components/UploadDocument";
import EditInfo2 from "./modal/EditInfo2";
import EditInfo4 from "./modal/EditInfo4";
import Passport from "./modal/Passport";
import AddPassport from "./modal/AddPassport";
import AddVisa from "./modal/AddVisa";
import Visa from "./modal/Visa";
import EditMedical from "./modal/EditMedical";

const ProfileDetails = ({ profile, setSelectedProfile, setActiveTab, refreshTable }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [profileInit, setProfileInit] = useState(profile);
  const [isOpen, setIsOpen] = useState(false);
  const [isInfo2Open, setIsInfo2Open] = useState(false);
  const [isInfo3Open, setIsInfo3Open] = useState(false);
  const [isInfo4Open, setIsInfo4Open] = useState(false);
  const [isInfo5Open, setIsInfo5Open] = useState(false);
  const [isInfo6Open, setIsInfo6Open] = useState(false);
  const [isInfo7Open, setIsInfo7Open] = useState(false);
  const [isInfo8Open, setIsInfo8Open] = useState(false);
  const [isDistributionOpen, setIsDistributionOpen] = useState(false);
  const [isRecipientOpen, setIsRecipientOpen] = useState(false);
  const [isRecipientEdit, setIsRecipientEdit] = useState(false);
  const [passportIndex, setPassportIndex] = useState(0);
  const [visaIndex, setVisaIndex] = useState(0);
  const [isMedicalOpen, setIsMedicalOpen] = useState(false);

  // Update profileInit when profile prop changes
  useEffect(() => {
    setProfileInit(profile);
  }, [profile]);

  // Function to refresh profile data from server
  const refreshProfileData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/employee/get/${profile.id}`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      });
      if (response.data) {
        setProfileInit(response.data);
        setSelectedProfile(response.data);
        // Also refresh the table
        if (refreshTable) {
          refreshTable();
        }
      }
    } catch (error) {
      console.error("Error refreshing profile data:", error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const dimensions = "w-full max-w-4xl min-h-[80%] ";
  // const [showSubMenu, setShowSubMenu] = useState(false);

  const handlePassportEdit = (index) => {
    setIsInfo5Open(true);
    setPassportIndex(index);
  };

  const handleVisaEdit = (index) => {
    setIsInfo8Open(true);
    setVisaIndex(index);
  };

  const deleteProfile = (id) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record?",
      icon: "warning", //The right way
      dangerMode: "red",
      closeModal: false,
      buttons: ["No", "Yes"], //The right way to do it in Swal1
    }).then((isConfirm) => {
      if (isConfirm) {
        axios
          .delete(`${apiUrl}/employee/delete/${id}`, {
            headers: {
              loginToken: localStorage.getItem("loginToken"),
            },
          })
          .then((res) => {
            if (res.data.message) {
              swal({
                title: "Removing",
                icon: "success",
                timer: 3000,
                buttons: false,
                text: "Profile has been deleted",
              });

              setActiveTab(1);
              setSelectedProfile({});
            }
          })
          .catch((err) => {
            swal({
              title: "Error",
              icon: "error",
              text: err.message,
            });
            console.log(err);
          });
      }
    });
  };

  const downloadProfilePDF = () => {
    const doc = new jsPDF();
    const blue = [41, 128, 185];
    const lightBlue = [214, 234, 248];
    const lightGray = [245, 245, 245];
    const borderGray = [200, 200, 200];
    const L = 15;   // left margin
    const W = 180;  // content width
    const midX = L + W / 2;

    const fmtDate = (val) => {
      if (!val) return 'N/A';
      return val.toString().split('T')[0];
    };

    // ── Header ──────────────────────────────────────────────
    doc.setFillColor(...blue);
    doc.rect(0, 0, 210, 42, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.text("RAHMAN GROUP", 105, 18, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.text("Employee Profile Report", 105, 30, { align: "center" });
    doc.setTextColor(0, 0, 0);

    let y = 52;

    // ── Section helper ────────────────────────────────────────
    const sectionTitle = (title) => {
      if (y > 265) { doc.addPage(); y = 15; }
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.setTextColor(...blue);
      doc.text(title, L, y);
      doc.setDrawColor(...blue);
      doc.setLineWidth(0.4);
      doc.line(L, y + 1, L + W, y + 1);
      doc.setTextColor(0, 0, 0);
      y += 8;
    };

    const rowPair = (lLabel, lVal, rLabel, rVal) => {
      if (y > 270) { doc.addPage(); y = 15; }
      doc.setFont("helvetica", "bold"); doc.setFontSize(9);
      doc.text(lLabel + ":", L + 2, y);
      doc.setFont("helvetica", "normal");
      doc.text(String(lVal ?? 'N/A'), L + 40, y);
      if (rLabel) {
        doc.setFont("helvetica", "bold");
        doc.text(rLabel + ":", midX + 2, y);
        doc.setFont("helvetica", "normal");
        doc.text(String(rVal ?? 'N/A'), midX + 40, y);
      }
      y += 7;
    };

    const subHeader = (title) => {
      if (y > 270) { doc.addPage(); y = 15; }
      doc.setFillColor(230, 230, 230);
      doc.rect(L, y - 4, W, 7, 'F');
      doc.setFont("helvetica", "bold"); doc.setFontSize(9);
      doc.setTextColor(60, 60, 60);
      doc.text(title, L + 2, y);
      doc.setTextColor(0, 0, 0);
      y += 7;
    };

    // ── Personal Information ─────────────────────────────────
    sectionTitle("PERSONAL INFORMATION");
    rowPair("Full Name",    `${profileInit.firstName} ${profileInit.lastName}`, "Date of Birth", fmtDate(profileInit.DOB));
    rowPair("Nationality",  profileInit.nationality,     "Blood Group", profileInit.Health?.bloodGroup || 'N/A');
    rowPair("Email",        profileInit.email,           "Mobile",      profileInit.mobile);
    rowPair("Agent",        profileInit.Agent?.name || 'N/A', "Status", profileInit.status);
    y += 4;

    // ── Medical Information ──────────────────────────────────
    sectionTitle("MEDICAL INFORMATION");
    rowPair("MC Ref No",   profileInit.Health?.mcRefNo || 'N/A',         "MC Status",     profileInit.Health?.mcStatus || 'N/A');
    rowPair("MC Approval", fmtDate(profileInit.Health?.mcApprovalDate),  "MC Valid Until", fmtDate(profileInit.Health?.mcValidUntil));
    rowPair("MC With",     profileInit.Health?.mcWith || 'N/A',          "Blood Group",   profileInit.Health?.bloodGroup || 'N/A');
    y += 4;

    // ── Emergency Contacts ───────────────────────────────────
    if (profileInit.EmergencyContacts?.length > 0) {
      sectionTitle("EMERGENCY CONTACTS");
      profileInit.EmergencyContacts.forEach((c, i) => {
        if (profileInit.EmergencyContacts.length > 1) subHeader(`Contact ${i + 1}`);
        rowPair("Full Name", c.fullName, "Mobile", c.mobile);
        if (i === 0) rowPair("Blood Group", profileInit.Health?.bloodGroup || 'N/A', "", "");
      });
      y += 4;
    }

    // ── Passport Information ─────────────────────────────────
    if (profileInit.Passports?.length > 0) {
      sectionTitle("PASSPORT INFORMATION");
      profileInit.Passports.forEach((p, i) => {
        if (profileInit.Passports.length > 1) subHeader(`Passport ${i + 1}`);
        rowPair("Passport No",  p.passportNo,           "Status",      p.status || 'N/A');
        rowPair("Issue Date",   fmtDate(p.issueDate),   "Expiry Date", fmtDate(p.expiryDate));
      });
      y += 4;
    }

    // ── Visa Information ─────────────────────────────────────
    if (profileInit.Visas?.length > 0) {
      sectionTitle("VISA INFORMATION");
      profileInit.Visas.forEach((v, i) => {
        if (profileInit.Visas.length > 1) subHeader(`Visa ${i + 1}`);
        rowPair("Status",     v.status || 'N/A',       "", "");
        rowPair("Issue Date", fmtDate(v.issueDate),   "Expiry Date", fmtDate(v.expiryDate));
      });
    }

    // ── Footer ───────────────────────────────────────────────
    const total = doc.internal.getNumberOfPages();
    for (let i = 1; i <= total; i++) {
      doc.setPage(i);
      doc.setFontSize(8); doc.setTextColor(150, 150, 150);
      doc.text(`Generated on ${new Date().toLocaleDateString()}`, L, 290);
      doc.text(`Page ${i} of ${total}`, L + W, 290, { align: "right" });
    }

    const pdfUrl = URL.createObjectURL(doc.output('blob'));
    window.open(pdfUrl, '_blank');
  };

  return (
    <div className="w-full h-full flex flex-col flex-1 bg-gray-50 p-2 sm:p-4">
      {profile && Object.keys(profile).length > 0 && (
        <div className="w-full flex flex-wrap items-center justify-end px-2 sm:px-3 py-2 gap-x-3 gap-y-2 mb-6">
          <button
            className="flex text-sm items-center py-2 px-4 gap-2 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 transition-colors duration-200 text-gray-700"
            onClick={() => setIsModalOpen(true)}
          >
            <AiOutlineUpload size={16} />
            Manage Attachments
          </button>
          <button
            className="flex text-sm items-center py-2 px-4 gap-2 border border-blue-300 rounded-lg shadow-sm bg-white hover:bg-blue-50 transition-colors duration-200 text-blue-600"
            onClick={downloadProfilePDF}
          >
            <AiOutlineDownload size={16} />
            Download
          </button>
          <button
            className="flex text-sm items-center py-2 px-4 gap-2 border border-red-300 rounded-lg shadow-sm bg-white hover:bg-red-50 transition-colors duration-200 text-red-600"
            onClick={() => deleteProfile(profileInit.id)}
          >
            <AiFillDelete size={16} />
            Delete Profile
          </button>
        </div>
      )}

      {profile && Object.keys(profile).length > 0 ? (
        <div className="space-y-6">
          {/* Modal for Upload Document */}
          {isModalOpen && (
            <Modal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              dimensions={dimensions}
            >
              <UploadDocument
                data={profileInit}
                setIsModalOpen={setIsModalOpen}
              />
            </Modal>
          )}

          {/* Personal Details Section */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            <div className="bg-gray-100 border-b border-gray-200 px-4 sm:px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <AiOutlineUser className="text-gray-600 text-xl" />
                  <h3 className="text-lg font-semibold text-gray-900">
                    Personal Details
                  </h3>
                </div>
                <button
                  onClick={() => setIsOpen(true)}
                  className="flex items-center gap-2 border border-gray-300 bg-white text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-50 transition-colors duration-200 text-sm"
                >
                  <AiFillEdit size={14} />
                  Update
                </button>
              </div>
              <p className="text-gray-600 text-sm mt-1">
                Basic personal information and contact details
              </p>
            </div>

            <div className="p-2">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
                  <AiOutlineUser className="text-gray-600 text-base" />
                  <div>
                    <p className="text-xs font-medium text-gray-500">Full Name</p>
                    <p className="text-sm font-semibold text-gray-900">{profileInit.firstName} {profileInit.lastName}</p>
                  </div>
                </div>

                <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
                  <AiOutlineCalendar className="text-gray-600 text-base" />
                  <div>
                    <p className="text-xs font-medium text-gray-500">Date of Birth</p>
                    <p className="text-sm font-semibold text-gray-900">{profileInit.DOB}</p>
                  </div>
                </div>

                <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
                  <AiOutlineGlobal className="text-blue-600 text-base" />
                  <div>
                    <p className="text-xs font-medium text-gray-500">Nationality</p>
                    <p className="text-sm font-semibold text-gray-900">{profileInit.nationality}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
                  <AiOutlineMail className="text-gray-600 text-base" />
                  <div>
                    <p className="text-xs font-medium text-gray-500">Email Address</p>
                    <p className="text-sm font-semibold text-gray-900 break-words">{profileInit.email}</p>
                  </div>
                </div>

                <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
                  <AiOutlinePhone className="text-gray-600 text-base" />
                  <div>
                    <p className="text-xs font-medium text-gray-500">Mobile Number</p>
                    <p className="text-sm font-semibold text-gray-900">{profileInit.mobile}</p>
                  </div>
                </div>

                <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
                  <AiOutlineTeam className="text-gray-600 text-base" />
                  <div>
                    <p className="text-xs font-medium text-gray-500">Agent Name</p>
                    <p className="text-sm font-semibold text-gray-900">{profileInit.Agent?.name || 'N/A'}</p>
                  </div>
                </div>

                <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                  <AiOutlineCheckCircle className="text-gray-600 text-base" />
                  <div>
                    <p className="text-xs font-medium text-gray-500">Status</p>
                    <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                      profileInit.status === 'Active' 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {profileInit.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Passports Section */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            <div className="bg-gray-100 border-b border-gray-200 px-4 sm:px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <AiOutlineIdcard className="text-gray-600 text-xl" />
                  <h3 className="text-lg font-semibold text-gray-900">
                    Passports
                  </h3>
                </div>
                <button
                  onClick={() => setIsInfo6Open(true)}
                  className="flex items-center gap-2 border border-gray-300 bg-white text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-50 transition-colors duration-200 text-sm"
                >
                  <AiFillPlusCircle size={14} />
                  Add Passport
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Passport No
                    </th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Issue Date
                    </th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Expiry Date
                    </th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {profileInit.Passports && profileInit.Passports.length > 0 ? (
                    profileInit.Passports.map((passport, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {passport.passportNo}
                        </td>
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {passport.issueDate || 'N/A'}
                        </td>
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {passport.expiryDate}
                        </td>
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <button
                            onClick={() => handlePassportEdit(index)}
                            className="inline-flex items-center px-3 py-1 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200"
                          >
                            <AiFillEdit size={14} className="mr-1" />
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="px-3 sm:px-6 py-8 text-center text-gray-500">
                        No passports found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Visas Section */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            <div className="bg-gray-100 border-b border-gray-200 px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <AiOutlineGlobal className="text-gray-600 text-xl" />
                  <h3 className="text-lg font-semibold text-gray-900">
                    Visas
                  </h3>
                </div>
                <button
                  onClick={() => setIsInfo7Open(true)}
                  className="flex items-center gap-2 border border-gray-300 bg-white text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-50 transition-colors duration-200 text-sm"
                >
                  <AiFillPlusCircle size={14} />
                  Add Visa
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Issue Date
                    </th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Expiry Date
                    </th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {profileInit.Visas && profileInit.Visas.length > 0 ? (
                    profileInit.Visas.map((visa, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap">
                          <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                            visa.status === 'Active' 
                              ? 'bg-green-100 text-green-800' 
                              : visa.status === 'Expired'
                              ? 'bg-red-100 text-red-800'
                              : 'bg-yellow-100 text-yellow-800'
                          }`}>
                            {visa.status}
                          </span>
                        </td>
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {visa.issueDate || 'N/A'}
                        </td>
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {visa.expiryDate}
                        </td>
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <button
                            onClick={() => handleVisaEdit(index)}
                            className="inline-flex items-center px-3 py-1 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200"
                          >
                            <AiFillEdit size={14} className="mr-1" />
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="px-3 sm:px-6 py-8 text-center text-gray-500">
                        No visas found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            <div className="bg-gray-100 border-b border-gray-200 px-4 sm:px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <AiOutlineHeart className="text-gray-600 text-xl" />
                  <h3 className="text-lg font-semibold text-gray-900">Medical Information</h3>
                </div>
                <button
                  onClick={() => setIsMedicalOpen(true)}
                  className="flex items-center gap-2 border border-gray-300 bg-white text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-50 transition-colors duration-200 text-sm"
                >
                  <AiFillEdit size={14} />
                  Update
                </button>
              </div>
              <p className="text-gray-600 text-sm mt-1">Medical certificate details stored for this employee.</p>
            </div>
            <div className="p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p className="text-xs font-medium text-gray-500">MC Reference No</p>
                  <p className="text-sm font-semibold text-gray-900">{profileInit.Health?.mcRefNo || 'N/A'}</p>
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p className="text-xs font-medium text-gray-500">MC Approval Date</p>
                  <p className="text-sm font-semibold text-gray-900">{profileInit.Health?.mcApprovalDate?.slice(0, 10) || 'N/A'}</p>
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p className="text-xs font-medium text-gray-500">MC Valid Until</p>
                  <p className="text-sm font-semibold text-gray-900">{profileInit.Health?.mcValidUntil?.slice(0, 10) || 'N/A'}</p>
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p className="text-xs font-medium text-gray-500">MC Status</p>
                  <p className="text-sm font-semibold text-gray-900">{profileInit.Health?.mcStatus || 'N/A'}</p>
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p className="text-xs font-medium text-gray-500">MC With</p>
                  <p className="text-sm font-semibold text-gray-900">{profileInit.Health?.mcWith || 'N/A'}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Emergency Contacts Section */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            <div className="bg-gray-100 border-b border-gray-200 px-4 sm:px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <AiOutlinePhone className="text-gray-600 text-xl" />
                  <h3 className="text-lg font-semibold text-gray-900">
                    Emergency Contacts
                  </h3>
                </div>
                <button
                  onClick={() => setIsInfo3Open(true)}
                  className="flex items-center gap-2 border border-gray-300 bg-white text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-50 transition-colors duration-200 text-sm"
                >
                  <AiFillEdit size={14} />
                  Update
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Full Name
                    </th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Mobile Number
                    </th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Blood Group
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {profileInit.EmergencyContacts && profileInit.EmergencyContacts.length > 0 ? (
                    profileInit.EmergencyContacts.map((contact, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {contact.fullName}
                        </td>
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {contact.mobile}
                        </td>
                        <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {index === 0 ? (profileInit.Health?.bloodGroup || '—') : ''}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="px-3 sm:px-6 py-4 text-center text-gray-500">
                        No emergency contacts found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-y-6 py-12">
          <div className="text-center">
            <AiOutlineUser className="mx-auto h-24 w-24 text-gray-400" />
            <p className="mt-4 text-lg font-medium text-gray-900">No Profile Selected</p>
            <p className="mt-2 text-sm text-gray-500">Please select a profile to view details</p>
          </div>
          <button
            onClick={() => setActiveTab(1)}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 shadow-sm"
          >
            Select Profile
          </button>
        </div>
      )}

      {/* All Modals */}
      {isMedicalOpen && (
        <EditMedical
          profileInit={profileInit}
          isOpen={isMedicalOpen}
          setIsOpen={setIsMedicalOpen}
          onUpdateSuccess={refreshProfileData}
        />
      )}

      {isOpen && (
        <EditInfo1
          profileInit={profileInit}
          setProfileInit={setProfileInit}
          isOpen={isOpen}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsOpen={setIsOpen}
          onUpdateSuccess={refreshProfileData}
        />
      )}

      {isInfo2Open && (
        <EditInfo2
          profileInit={profileInit}
          setProfileInit={setProfileInit}
          isInfo2Open={isInfo2Open}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsInfo2Open={setIsInfo2Open}
          onUpdateSuccess={refreshProfileData}
        />
      )}

      {isInfo3Open && (
        <EditInfo3
          profileInit={profileInit}
          setProfileInit={setProfileInit}
          isInfo3Open={isInfo3Open}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsInfo3Open={setIsInfo3Open}
          refreshProfileData={refreshProfileData}
        />
      )}

      {isInfo4Open && (
        <EditInfo4
          profileInit={profileInit}
          setProfileInit={setProfileInit}
          isInfo4Open={isInfo4Open}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsInfo4Open={setIsInfo4Open}
          onUpdateSuccess={refreshProfileData}
        />
      )}

      {isInfo5Open && (
        <Passport
          profileInit={profileInit}
          setProfileInit={setProfileInit}
          isInfo5Open={isInfo5Open}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsInfo5Open={setIsInfo5Open}
          index={passportIndex}
        />
      )}

      {isInfo6Open && (
        <AddPassport
          profileInit={profileInit}
          setProfileInit={setProfileInit}
          isInfo6Open={isInfo6Open}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsInfo6Open={setIsInfo6Open}
          index={passportIndex}
        />
      )}

      {isInfo7Open && (
        <AddVisa
          profileInit={profileInit}
          setProfileInit={setProfileInit}
          isInfo7Open={isInfo7Open}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsInfo7Open={setIsInfo7Open}
          index={visaIndex}
          refreshProfileData={refreshProfileData}
        />
      )}

      {isInfo8Open && (
        <Visa
          profileInit={profileInit}
          setProfileInit={setProfileInit}
          isInfo8Open={isInfo8Open}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsInfo8Open={setIsInfo8Open}
          index={visaIndex}
          refreshProfileData={refreshProfileData}
        />
      )}

      {isDistributionOpen && (
        <Distribute
          ProfileInit={profileInit}
          setProfileInit={setProfileInit}
          isDistributionOpen={isDistributionOpen}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsDistributionOpen={setIsDistributionOpen}
        />
      )}

      {isRecipientOpen && (
        <Recipient
          ProfileInit={profileInit}
          setProfileInit={setProfileInit}
          isRecipientOpen={isRecipientOpen}
          selectedProfile={profile}
          setSelectedProfile={setSelectedProfile}
          setIsRecipientOpen={setIsRecipientOpen}
          isRecipientEdit={isRecipientEdit}
        />
      )}
    </div>
  );
};

export default ProfileDetails;
